import yup from "../../../../utils/yup-extended";
import {
  createLiveEventBasicFormStepFormValidationSchema,
  CreateLiveEventBasicFormStepFormValues,
} from "../../create-live-event/multi-step/basic-form/schema-validation";
import {CoverImagesItemResponse} from "../../../../react-query-hooks/products/types";

export const editProductBasicFormStepFormValidation = yup.object().shape({
  cover_images: yup
    .array()
    .min(1, "Add at least one image")
    .max(5, "You can only add a maximum of 5 images"),
});

export const editLiveEventBasicFormStepFormValidationSchema =
  createLiveEventBasicFormStepFormValidationSchema.concat(
    editProductBasicFormStepFormValidation
  );

export type EditLiveEventBasicFormStepFormValuesYup = yup.InferType<
  typeof editLiveEventBasicFormStepFormValidationSchema
>;

export type EditLiveEventBasicFormStepFormValues =
  CreateLiveEventBasicFormStepFormValues & {
    cover_images: CoverImagesItemResponse[];
  };
